import React, { useState, useEffect, useReducer, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    Card,
    CardBody,
    CardHeader,
    Col,
    Form,
    FormText,
    FormGroup,
    Input,
    Label,
    Row,
} from 'reactstrap';
// import components
import Page from '../components/Page';
import ButtonLoader from '../mycomponents/Layout/ButtonLoader';
// import lib
import toastAlert from '../lib/toastAlert';
import isEmpty from '../lib/isEmpty';
import handleReducer, { textChange, onBlur, fileChange, formData } from '../lib/handleChange';
// import validation
import { profileValid } from '../validation/auth.validation';
// import api
import { updateProfile } from '../api/admin';

const title = "Profile";
const initialFormValue = {
    name: '',
    email: '',
    profile: ''
};

const ProfilePage = () => {

    // hooks
    const dispatch = useDispatch();
    // redux-state
    const profileDoc = useSelector((state) => state?.profile);
    // state
    const [formValue, setFormValue] = useReducer(handleReducer, initialFormValue);
    const [touched, setTouched] = useState({});
    const [loader, setLoader] = useState(false);
    const [errors, setErrors] = useState({});

    const { name, email } = formValue;

    const handleChange = (e) => textChange(e, setFormValue);
    const handleFileChange = (e) => fileChange(e, setFormValue);
    const handleBlur = (e) => onBlur(e, setTouched)

    const handleSubmit = useCallback(async (e) => {
        e.preventDefault();
        try {
            setLoader(true)
            let data = formData(formValue)
            const { status, errors, message } = await updateProfile(data, dispatch);
            setLoader(false)
            if (status === true) {
                toastAlert('success', message, 'updateProfile');
                setFormValue({ type: 'RESET', value: { email, name } })
                setTouched({})
                setErrors({});
                const fileInput = document.getElementById('fileInput');
                if (fileInput) {
                    fileInput.value = '';  // Clear the file input name value
                }
            } else if (errors) {
                setErrors(errors)
            } else if (message) toastAlert('error', message, 'updateProfile')

        } catch (err) {
            // console.log(err, 'errrr')
        }
    }, [formValue, dispatch]);

    useEffect(() => {
        if (!isEmpty(profileDoc)) {
            const data = {
                name: profileDoc?.name,
                email: profileDoc?.email,
                // profile: profileDoc?.profile
            }
            setFormValue({ type: 'INITIAL_SET', value: data })
        }
    }, [profileDoc]);

    useEffect(() => {
        const { status, errors } = profileValid(formValue);
        if (!status) setErrors(errors);
        else setErrors({})
    }, [formValue])
    // console.log(formValue, errors, 'errr')
    return (
        <Page title={title} breadcrumbs={[{ name: title, active: true }]}>
            <Row>
                <Col>
                    <Card>
                        <CardHeader>{title}</CardHeader>
                        <CardBody>
                            <Form>
                                <Row>
                                    <Col xl={6} lg={12} md={12}>
                                        <FormGroup>
                                            <Label for="exampleEmail">Name</Label>
                                            <Input
                                                type="text"
                                                name="name"
                                                value={name}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                valid={isEmpty(errors.name)}
                                            />
                                            {touched.name && <span className='text-danger'>{errors.name}</span>}
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="exampleEmail">Email</Label>
                                            <Input
                                                type="text"
                                                name="email"
                                                value={email}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                valid={isEmpty(errors.email)}
                                            />
                                            {touched.email && <span className='text-danger'>{errors.email}</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col xl={6} lg={12} md={12}>
                                        <FormGroup>
                                            <Label for="exampleEmail">Code</Label>
                                            <Input
                                                id={'fileInput'}
                                                type="file"
                                                name="profile"
                                                onChange={handleFileChange}
                                                onBlur={handleBlur}
                                                valid={isEmpty(errors.profile)}
                                            />
                                            <FormText color="muted">
                                                Files only allowed for jpg, jpeg, png, webp.
                                            </FormText>
                                            {touched.profile && <span className='text-danger'>{errors.profile}</span>}
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <ButtonLoader
                                    spinnerSize="sm"
                                    loader={loader}
                                    color={"secondary"}
                                    text={'Save'}
                                    onClick={handleSubmit}
                                    disabled={!isEmpty(errors)}
                                />
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Page>
    );
};

export default ProfilePage;